/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './svg.scss';
import './modifier/icon.scss';
import './modifier/centered.scss';
